import type { ReactNode } from 'react'
import styles from './FormSubmission.module.css'

export interface FormSubmissionProps {
  summary: ReactNode
  submission: ReactNode
}

export function FormSubmission({ summary, submission }: FormSubmissionProps) {
  return (
    <div>
      <Block>{summary}</Block>
      <Block>{submission}</Block>
    </div>
  )
}

interface BlockProps {
  children?: ReactNode
}

function Block({ children }: BlockProps) {
  return <div className={styles.block}>{children}</div>
}
